import React, { FC } from 'react'
import { FieldInputProps, FormikProps } from 'formik'
import { TextareaAutosize } from '@mui/base'
import styles from './AddCommentNewsField.module.scss'

interface Props {
  field: FieldInputProps<any>
  form: FormikProps<any>
  placeholder: string
  isDisabled?: boolean
}

const AddCommentNewsField: FC<Props> = ({ field: { name, onChange, value, onBlur }, form: { touched, errors }, placeholder, isDisabled }: Props) => (
  <div className={styles.wrapper}>
    <TextareaAutosize
      className={styles.textarea}
      onChange={onChange}
      maxRows={5}
      name={name}
      value={value}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={isDisabled}
    />
    <div className={styles.error}>{`${(touched?.[name] && errors?.[name]) || errors?.image || `\u00A0`}`}</div>
  </div>
)
export default AddCommentNewsField
